import CalendarItemNotificationPayload from 'owa-service/lib/contract/CalendarItemNotificationPayload';
import upsertCalendarEvent from '../../../store/apis/upsertCalendarEvent';
import { calendarEvent } from 'mini-calendar-event-converter';

/**
 * Handles a notification for a single (non-recurring) calendar item
 */
export default function handleSingleItemNotification(
    notification: CalendarItemNotificationPayload
) {
    const calEvent = calendarEvent(notification.Item);
    upsertCalendarEvent(calEvent);
}
